<template>
  <div class="flex h-[calc(100vh-var(--infuse-content-offset,0px))] flex-col overflow-y-hidden">
    <slot name="top-bar" />
    <main
      class="grid min-h-0 flex-1 grid-cols-1 grid-rows-[auto_1fr] gap-4 p-4 max-lg:pb-24 md:gap-6 md:p-8 md:pt-[var(--infuse-page-padding-top,2rem)]"
    >
      <slot></slot>
    </main>
  </div>
</template>
